// removed by extract-text-webpack-plugin
module.exports = {"container":"container___1w_nf","content":"content___hpsEi"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/UserHome/UserHome.module.css
// module id = 185
// module chunks = 0